import { say } from "./say.ts";

const THINKING = {
  off: "thinking.off",
  on: "thinking.on",
  low: "thinking.low",
  medium: "thinking.medium",
  high: "thinking.high",
  max: "thinking.max",
} as const;

const ROLES = { owner: "role.owner", admin: "role.admin", member: "role.member" } as const;

const STOPS = {
  refused: "stop.refused",
  spent: "stop.spent",
  broke: "stop.broke",
  looped: "stop.looped",
  vanished: "stop.vanished",
  tooled: "stop.tooled",
  halted: "stop.halted",
} as const;

export const thinkingLabel = (value: string): string =>
  value in THINKING ? say(THINKING[value as keyof typeof THINKING]) : value;

export const roleLabel = (value: string): string =>
  value in ROLES ? say(ROLES[value as keyof typeof ROLES]) : value;

export const stopLabel = (value: string): string =>
  value in STOPS ? say(STOPS[value as keyof typeof STOPS]) : value;
